import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import InfoWindows from "./InfoWindows";
import {
  getDistance,
  getUrl,
  // syncItems,
  // syncMap,
  // syncMap,
} from "../../utils/staticMethods";
import {
  // AdvancedMarker,
  // Pin,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import { imageSet } from "../../pages/icons/AssetIcon/IconList";
import defaultImg from "../../assets/img/icon/Aircraft/Airliner_Black.png";
// import {
//   MarkerClusterer,
//   SuperClusterAlgorithm,
// } from "@googlemaps/markerclusterer";
import useSrlHelper from "../../hooks/useSrlHelper";
// import { Badge } from "react-bootstrap";
import useNearbyItemsManager from "../../hooks/useNearbyItemsManager";
import { Button, Modal } from "react-bootstrap";
import CommonTable from "../tables/CommonTable";
// import { current } from "@reduxjs/toolkit";

const CommonMapItems = ({
  showNearByAssets,
  showNearByZones,
  nearbyItems,
  onCurrentChanged,
  clusteredItemIds,
  setClusteredItemIds,
}) => {
  const [showModal, setShow] = useState(false);
  const [clusteredItems, setClusteredItems] = useState([]);
  // const assetsCurrent = useRef(assets);
  const { getAssetColumnsForNearByAssets } = useSrlHelper();
  const [tableColumns] = useState(getAssetColumnsForNearByAssets(setShow));

  const handleClusteredItemsSelected = (ids) => {
    setClusteredItemIds(ids);
  };

  const { groups, zones } = useNearbyItemsManager({
    showNearByAssets,
    showNearByZones,
    nearbyItems,
    onCurrentChanged,
    onClusteredItemsSelected: handleClusteredItemsSelected,
  });

  useEffect(() => {
    if (!clusteredItemIds) return;

    var items = clusteredItemIds.map((value, index) => {
      return nearbyItems.find((_) => _.id === value);
    });
    if (items && items.length > 0) {
      setClusteredItems(items);
      setShow(true);
    }
  }, [nearbyItems, clusteredItemIds]);

  const hideModel = () => {
    setShow(false);
    setClusteredItems([]);
    setClusteredItemIds([]);
  };

  // const [selectedItemId, setSelectedItemId] = useState();

  // const [updateInfoWindows, setUpdateInfoWindows] = useState(false);

  // const [infoWindowIds, setInfoWindowIds] = useState([]);

  // const trackedItemsMarkersRef = useRef(new Map());
  // const [markerClustererReady, setMarkerClustererReady] = useState(false);

  // useEffect(() => {
  //   if (!nearbyTrackedItems) return;
  //   if (!markerLib) return;

  //   // markerClustererRef.current.render();

  //   // syncMap(markersStateRef.current, nearbyTrackedItems, {
  //   //   onAdd: (item) => createTrackedItemMarker(item), // returns marker instance
  //   //   onModify: (item, marker) => updateTrackedItemMarker(marker, item),
  //   //   onDelete: (marker) => removeTrackedItemMarker(marker),
  //   // });

  //   // debugger;
  //   console.log("fff ", JSON.stringify(nearbyTrackedItems));

  //   // debugger;
  //   syncItems(markersStateRef.current, nearbyTrackedItems, {
  //     createGroupMarker: function (lat, lng, id) {
  //       // const item = markersStateRef.current.itemsById.get(id);

  //       var marker = new markerLib.AdvancedMarkerElement({
  //         // map: map,
  //         position: {
  //           lat,
  //           lng,
  //         },
  //       });

  //       return marker;
  //     },
  //     updateGroupMarker: function (group) {},
  //     destroyGroupMarker: function (group) {
  //       //markerClustererRef.current.removeMarker(group.marker, true);
  //     },
  //   });

  //   console.log("%crender cluster", "backgroud: #aaffaa");
  //   // markerClustererRef.current.render();
  //   // Forces redraw
  //   // map.setOptions({ center: map.getCenter() });
  //   // setUpdateInfoWindows(true);
  // }, [nearbyTrackedItems, markerLib, markerClustererReady]);

  // const createTrackedItemMarker = useCallback(
  //   (item) => {
  //     const pos = new coreLib.LatLng(
  //       Number(item.latitude),
  //       Number(item.longitude)
  //     );
  //     var marker = new markerLib.AdvancedMarkerElement({
  //       map: map,
  //       position: pos,
  //       anchorLeft: "0%",
  //       anchorTop: "-50%",
  //     });
  //     const myDiv = document.createElement("div");
  //     var displayName = itemDisplayName(item);
  //     const imageSrc = imageSet[getUrl(item.icon)]
  //       ? require("../../assets/img/icon/" + imageSet[getUrl(item.icon)])
  //           .default
  //       : defaultImg;
  //     // ReactDOM.render(
  //     //   <div className="d-flex flex-column align-items-center">
  //     //     <img src={imageSrc} width={"24px"} alt="Tracked Item Marker" />
  //     //     <div className="mt-4 px-2 text-nowrap text-break text-white position-absolute bg-black bg-opacity-25">
  //     //       {displayName}
  //     //     </div>
  //     //   </div>,
  //     //   myDiv
  //     // );
  //     ReactDOM.render(
  //       <span>
  //         <img
  //           src={imageSrc}
  //           width={"24px"}
  //           alt="Tracked Item Marker"
  //           style={{ position: "relative", transform: "translate(-50%,-50%)" }}
  //         />
  //         <div
  //           className="mt-1 px-0 text-nowrap text-break text-white position-absolute bg-black bg-opacity-25"
  //           style={{ transform: "translate(-50%,-50%)" }}
  //         >
  //           {displayName}
  //         </div>
  //       </span>,
  //       myDiv
  //     );

  //     marker.appendChild(myDiv);
  //     marker.trackedItem = item;
  //     marker.trackedItem.showInfo = false;
  //     marker.style.translate = "0 12px";

  //     marker.addListener(
  //       "click",
  //       (e) => {
  //         // debugger;
  //         // const selectedItemId =
  //         //   e.domEvent?.srcElement?.parentElement?.parentElement?.trackedItem
  //         //     ?.id ?? "";

  //         marker.trackedItem.showInfo = !marker.trackedItem.showInfo;
  //         const selectedItemId = marker.trackedItem.id;

  //         setSelectedItemId(selectedItemId);
  //         onCurrentChanged &&
  //           onCurrentChanged({
  //             current: marker.trackedItem,
  //             // current: {
  //             //   lastPosition: marker.trackedItem,
  //             //   type: marker.trackedItem.type,
  //             // },
  //             marker: marker,
  //           });

  //         // var found =
  //         //   nearbyItemsRef.current &&
  //         //   nearbyItemsRef.current.find((_) => _.id === selectedItemId);

  //         // if (found) {
  //         //   onCurrentChanged({
  //         //     current: { lastPosition: found, type: found.type },
  //         //   });
  //         // setInfoWindowIds((prev) => {
  //         //   // toggle in array
  //         //   return prev.includes(selectedItemId)
  //         //     ? prev.filter((v) => v !== selectedItemId) // remove it
  //         //     : [...prev, selectedItemId]; // add it
  //         // });
  //       }

  //       // if (map.getZoom() < 18) {
  //       //   map.setZoom(18);
  //       // }

  //       // onCurrentChanged &&
  //       //   onCurrentChanged({
  //       //     selectedItemId:
  //       //       e.domEvent.srcElement.parentElement.parentElement.trackedItem.id,
  //       //     selectedMarker: e.do,
  //       //   });
  //     );

  //     markerClustererRef.current.addMarker(marker, true);

  //     return marker;
  //   },
  //   [markerLib]
  // );

  // const updateTrackedItemMarker = (marker, item) => {
  //   marker.trackedItem = Object.assign(marker.trackedItem, item);
  //   marker.position = {
  //     lat: parseFloat(item.latitude),
  //     lng: parseFloat(item.longitude),
  //   };
  //   //marker.trackedItem = item;
  //   return marker;
  // };

  // const removeTrackedItemMarker = useCallback((marker) => {
  //   markerClustererRef.current.removeMarker(marker, true);
  //   marker.setMap(null);
  // });

  // const handleSelectedChanged = useCallback(
  //   ({ selectedItemId }) => {},
  //   [setSelectedItemId, onCurrentChanged]
  // );

  return (
    <React.Fragment>
      {groups && (
        <InfoWindows
          groups={groups}
          nearbyItems={nearbyItems}
          // updateInfoWindows={updateInfoWindows}
          // setUpdateInfoWindows={setUpdateInfoWindows}
        />
      )}
      <Modal
        show={showModal}
        onHide={() => hideModel()}
        size={"lg"}
        style={{ zIndex: "9999999 !important;" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Total count {clusteredItems.length}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CommonTable data={clusteredItems} columns={tableColumns} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant={"secondary"} onClick={() => hideModel()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default CommonMapItems;
